<!--  支付抢购成功 -->
<template>
  <div v-if="bodyShow" class="rush-succ-main">
    <div class="qr-code">
        <div class="title">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/left-icon.png" />
            <span>领取成功</span>
            <img src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/right-icon.png" />
        </div>
        <!--  -->
        <div class="p">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/sj.png" />
            长按或截图保存二维码至手机相册
        </div>
        <div class="p">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/sj.png" />
            打开微信，点击右上角扫一扫
        </div>
        <div class="p on">
            <img src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/sj.png" />
            扫描相册内保存的二维码
        </div>
        <img class="line" src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/line.png" />
        <p>请按照上面步骤激活课程</p>
        <h5>(*未成功激活不能参加学习)</h5>
        <img  class="qr" src="https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/ff.png" />
    </div>
    <!-- <img src="@a/rush_purchase/ewm.jpg" class="qrcode" /> -->
    <!-- <div class="title">
      <img src="@a/rush_purchase/success-ico.png" alt="">
      支付成功
    </div>
    <h5 class="small">* 请务必关注公众号“生涯研习社”，否则无法<br/>上课，仅需3步即可关注~</h5> -->
    <!--  -->
    <!-- <div class="sc-box">
      <div class="bg-title">
        <div class="sc-cle"></div>
        步骤一&nbsp;&nbsp;复制“生涯研习社” 
      </div>
      <a v-clipboard:copy="'生涯研习社'" v-clipboard:success="onCopy" v-clipboard:error="onError" class="copy">立刻复制</a>
    </div> -->
    <!--  -->
    <!-- <div class="sc-box">
      <div class="bg-title">
        <div class="sc-cle"></div>
        步骤二&nbsp;&nbsp;通讯录中选择公众号
      </div>
      <img src="@a/rush_purchase/succ1.png" alt="">
    </div> -->
    <!--  -->
    <!-- <div class="sc-box  on3">
      <div class="bg-title">
        <div class="sc-cle"></div>
        步骤三&nbsp;&nbsp;点击“+”号，粘贴、搜索<br/>并关注“生涯研习社”公众号            
      </div>
      <p>* 回复关键词“特训营”，添加老师上课</p>
      <img src="@a/rush_purchase/succ2.png" alt="">
      <img class="line" src="@a/rush_purchase/succ-line.png" alt="">
      <img src="@a/rush_purchase/succ3.png" alt="">
      <img class="line" src="@a/rush_purchase/succ-line.png" alt="">
      <img src="@a/rush_purchase/succ4.png" alt="">
    </div> -->
  </div>
</template>

<script>
import { wxpay,orders } from "@/api/other";
export default {
    data(){
        return{
            bodyShow:false
        }
    },
    methods:{
      // 复制成功
      onCopy(e) {
        this.$toast('复制成功!');
      },
      // 复制失败
      onError(e) {
        this.$toast("复制失败");
      },
      pullData(){
        orders({
          buy_id:1
        }).then((data)=>{
          if (data.code == 10002) {
              this.$toast(data.data.msg);
              return false;
          }
          if(data.orders.length==0){
              this.$router.push('/rush_purchase');
              return
          }
          this.bodyShow = true;
          document.title = "7天“职业发展特训营”";
        });
      }
    },
    created(){
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.rush-succ-main{
  background-color: #f0f0f0;
  text-align: center;
  padding: 64px 0px 80px;
  .qrcode{
    width:6rem;
    height:6rem;
    margin:3rem auto 0;
  }
  .title{
    font-size: 36px;
    color: #6259FF;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 45px;
      height: 45px;
      margin-right: 25px;
    }
  }
  h5.small{
    font-size: 28px;
    color: #EB5032;
    line-height:37px;
    margin-bottom: 94px;
  }
  .sc-box{
    width: 690px; 
    margin: 0px auto 96px;
    background-color: #ffffff;
    border-radius:12px;
    position: relative;
    padding: 84px 0px 50px;
    img{
      width: 630px;
      margin: 0px 30px;
    }
    .bg-title{
      width: 547px;
      line-height:46px;
      line-height: 74px;
      background-color: #6259FF;
      color: #ffffff;
      font-size: 34px;
      position: relative;
      border-radius:0px 37px 37px 37px;
      position: absolute;
      top: -36px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;
      .sc-cle{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #ffffff;
        position: absolute;
        top: 6px;
        left: 6px;
      }
      
    }
    
    a.copy{
      display: block;
      width: 310px;
      line-height: 80px;
      background-color: #EB5032;
      color: #ffffff;
      border-radius:40px;
      font-size: 34px;
      margin: 0 auto;
    }
  }
  .sc-box.on3{
    padding: 110px 0px 50px;
    margin-bottom: 0px;
    .bg-title{
      line-height: 46px;
      height: 130px;
    }
    img.line{
      width: 100%;
      margin: 42px auto 22px;
    }
    p{
      font-size: 28px;
      color: #EB5032;
      text-align: center;
      margin-bottom: 68px;
    }
  }
}
.qr-code{
    width:750px;
    height:937px;
    background: url('https://themes-cdn.xjy.cn/statics/career/images/rush_purchase/qr-bg.png') no-repeat center;
    background-size: 100% 100%;
    padding:160px 94px 357px;
    .title{
        display:flex;
        font-size:46px;
        color:#FF8D1B;
        text-align:center;
        align-items: center;
        justify-content: center;
        line-height:1;
        margin-bottom:60px;
        span{
            margin:0 18px;
        }
        img{
            width:43px;
            height:16px;
        }
    }
    .p{
        font-size:30px;
        color:#061C2A;
        line-height:1;
        margin-bottom:40px;
        text-align:left;
        padding-left:17px;
        display: flex;
        align-items: baseline;
        img{
            width:18px;
            height:20px;
            margin-right:15px;
        }
    }
    .p.on{
        margin-bottom:50px;
    }
    .line{
        width:564px;
        height:5px;
        margin:0px auto 30px;
    }
    p{
        font-size:24px;
        color:#061C2A;
        line-height:1;
        margin-bottom:10px;
    }
    h5{
        font-size:28px;
        color:#FC3D1D;
        line-height:1;
    }
    .qr{
        width:230px;
        height:230px;
        margin-top:20px;
    }
}
</style>